import React from 'react';

export default function Required() {
  return (
    <span style={{color: "var(--color-error)"}}>*</span>
  )
}